import { useState } from "react";

import { SortOrder, SortRequest, SortRequestClass } from "@/shared/domain";

export type Sort<SortPropertyType> = {
    property: SortPropertyType;
    order: SortOrder;
};

type UseSortProps<SortPropertyType> = {
    sort: Sort<SortPropertyType>;
};

export type UseSortActions<SortPropertyType> = {
    getManualSortProperty(): string;
    getSort(): SortRequest<SortPropertyType>;
    setSort(property: SortPropertyType, order: SortOrder): void;
    updateSort(property: SortPropertyType): void;
};

export const useSort = <SortPropertyType>({
    sort,
}: UseSortProps<SortPropertyType>): [Sort<SortPropertyType>, UseSortActions<SortPropertyType>] => {
    const [state, setState] = useState<Sort<SortPropertyType>>(sort);
    const actions = {
        getManualSortProperty: () => {
            return state.order === SortOrder.Ascending ? `${state.property}` : `-${state.property}`;
        },
        getSort: () => {
            return new SortRequestClass(state.property, state.order);
        },
        setSort: (property: SortPropertyType, order: SortOrder) => {
            setState((s) => ({ ...s, property, order }));
        },
        updateSort: (property: SortPropertyType) => {
            setState((s) => ({
                ...s,
                property,
                order:
                    s.order === SortOrder.Descending || property !== state.property
                        ? SortOrder.Ascending
                        : SortOrder.Descending,
            }));
        },
    };
    return [state, actions];
};
